import React from 'react';
import { IContextOptions } from './global.interface';

export const SlLoginContext = 'mf_sllogin_container_context';
export const SlLoginActionsContext = 'mf_sllogin_container_actions_context';

export const ServiceContext = React.createContext<IContextOptions>(null);
